import { StripeCustomMigrationMessage } from './StripeCustomMigrationMessage';
import { PendingStripeCustomMigrationMessage } from './PendingStripeCustomMigrationMessage';

export const Messaging = () => {
  return (
    <>
      <PendingStripeCustomMigrationMessage />
      <StripeCustomMigrationMessage />
    </>
  );
};
